module.exports = __webpack_public_path__ + "img/4.2eb14c50.png";